import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs-compat/Observable';

import { OrderApiConfiguration } from '../order-api-configuration/app.constant.service';
import { ServiceBase } from '../../../infrastructure/serviceBase.component';
import { StockTransferDetails, StockTransferListItem, StockTransferRequest } from 'app/shared/models/orders-and-billing';

@Injectable()
export class InventoryTransferService extends ServiceBase {

    private actionUrl: string;
    private url: string;
    private confirmUrl: string;

    constructor(private http: HttpClient, private configuration: OrderApiConfiguration) {
        super();
        this.actionUrl = configuration.server;
        this.url = this.actionUrl + configuration.inventoryTransferRequest.url;
        this.confirmUrl = this.actionUrl + configuration.inventoryTransferRequest.confirmUrl;
    }

    getList = (warehouseCodes: string[]): Observable<StockTransferListItem[]> =>
        this.http.get<StockTransferListItem[]>(`${this.url}?warehouseCodes=${encodeURIComponent(warehouseCodes.join(','))}`);

    getByDocEntry = (docEntry: number): Observable<StockTransferDetails> =>
        this.http.get<StockTransferDetails>(`${this.url}/${docEntry}`);

    create = (request: StockTransferRequest): Observable<string> =>
        this.http.post<string>(this.url, JSON.stringify(request));

    confirm = (docEntry: number): Observable<number> =>
        this.http.post<number>(`${this.confirmUrl}/${docEntry}/Confirm`, null);
}
